import { Badge } from '@/components/ui/badge';

export default function StatusChip({ status }) {
  const statusConfig = {
    'DRAFT': { label: 'Draft', className: 'bg-slate-100 text-slate-800' },
    'SUBMITTED': { label: 'Submitted', className: 'bg-[#fff2d8] text-[#9a6500]' },
    'UNDER_REVIEW': { label: 'Under Review', className: 'bg-[#fff2d8] text-[#9a6500]' },
    'APPROVED': { label: 'Approved', className: 'bg-green-100 text-green-800' },
    'REJECTED': { label: 'Rejected', className: 'bg-red-100 text-red-800' },
    'READY_FOR_RECORDING': { label: 'Ready', className: 'bg-green-100 text-green-800' },
    'RECORDING_IN_PROGRESS': { label: 'Recording', className: 'bg-[#fff2d8] text-[#9a6500]' },
    'COMPLETED': { label: 'Completed', className: 'bg-[#fff2d8] text-[#9a6500]' },
    'NEED_PUBLISHER_APPROVAL': { label: 'Needs Approval', className: 'bg-orange-100 text-orange-800' }
  };

  const config = statusConfig[status] || { label: status, className: 'bg-slate-100 text-slate-800' };

  return (
    <Badge className={config.className}>
      {config.label}
    </Badge>
  );
}
